import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Paper, TextField, Typography } from '@material-ui/core';
import i18n from '../../i18n';

class VoucherRedeemPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      code: '',
      submitting: false,
      error: '',
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit() {
    const code = this.state.code.trim();
    if (!code) {
      this.setState({ error: i18n.t('plans.voucherRedeem.required') });
      return;
    }

    this.setState({ submitting: true, error: '' });
    this.props.onRedeem(code)
      .then(success => {
        if (success) this.setState({ code: '' });
      })
      .finally(() => this.setState({ submitting: false }));
  }

  render() {
    return (
      <Paper style={{padding: 16, marginTop: 24, marginBottom: 24}}>
        <Typography variant="subtitle1" gutterBottom>
          {i18n.t('plans.voucherRedeem.title')}
        </Typography>
        <div style={{display: 'flex', gap: 16, alignItems: 'flex-start', flexWrap: 'wrap'}}>
          <TextField
            label={i18n.t('plans.voucherRedeem.codeLabel')}
            value={this.state.code}
            onChange={event => this.setState({ code: event.target.value, error: '' })}
            error={!!this.state.error}
            helperText={this.state.error}
            variant="outlined"
            size="small"
            style={{flex: '1 1 240px'}}
          />
          <Button
            color="secondary"
            variant="contained"
            onClick={this.handleSubmit}
            disabled={this.state.submitting}
          >
            {i18n.t('plans.voucherRedeem.submit')}
          </Button>
        </div>
      </Paper>
    );
  }
}

VoucherRedeemPanel.propTypes = {
  onRedeem: PropTypes.func.isRequired,
};

export default VoucherRedeemPanel;
